import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useGetWeekPlannerCapacity = function (params) {
    var intl = useIntl();
    var _a = useQuery([TaskQueryKey.WeekPlannerCapacity, params.userId, params.from], function () {
        return api.base
            .get("".concat(config.appUrls.api, "/api/registration/WeekPlannerCapacity"), {
            params: params,
        })
            .then(function (res) { return res.data; });
    }, {
        enabled: !!params.userId && !!params.from && !!params.to,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        refetch: refetch,
    };
};
